import { isSuccess as isAlfaSuccess } from '@alfa-bank/site-helpers-form/meta/is-success';
import { validateEmail as validateAlfaEmail } from '@alfa-bank/site-helpers-form/validation/email';

import type { TValidator, TSuccess } from '../models';

/** Валидация необязательного емейла */
export const validateEmail: TValidator = optional => value => {
    if (optional && !value) return '';

    return validateAlfaEmail()(value);
};

/** В случае, если значение пустое - оно не является успешным */
export const isSuccess: TSuccess = ({ input, meta }) => {
    if (!input.value) return false;

    return isAlfaSuccess(meta);
};
